"use client";

import { isProd } from "@wb/env/isProd";
import { Analytics as SchoolAnalytics } from "@wb/ui/analytics";

export const Analytics = () => {
  return (
    <>
      {isProd() && (
        <SchoolAnalytics
          host="getgpt.app"
          enabled
          // debug
          ga
          clarity
          vercel
          amplitude
          cf
        />
      )}
    </>
  );
};
